// @ts-expect-error TS6192 -- MIGRATION: not approved, fix when encountered
import { methods, updateStateSettingsEndpoint } from '../../utils/apiHelper'
import { apiCall } from '../../utils/restclient'
import {
  CHANGE_SERVICE_ORDER,
  CHANGE_SERVICE_ORDER_ERROR,
  CHANGE_SERVICE_ORDER_SUCCESS,
  GET_SERVICE_TYPES,
  GET_SERVICE_TYPES_ERROR,
  GET_SERVICE_TYPES_SUCCESS,
  GET_STATES_SETTINGS,
  GET_STATES_SETTINGS_ERROR,
  GET_STATES_SETTINGS_SUCCESS,
} from './ManagementConstants'

export const getServiceTypes = () => {
  const endpoint = 'api/v1/servicetypes'
  const action = {
    type: GET_SERVICE_TYPES,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_SERVICE_TYPES_SUCCESS,
      error: GET_SERVICE_TYPES_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const changeServiceOrder = (newOrderOfServiceTypes) => {
  const endpoint = 'api/v1/servicetypes/reorder'
  const action = {
    type: CHANGE_SERVICE_ORDER,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, JSON.stringify(newOrderOfServiceTypes), {
      success: CHANGE_SERVICE_ORDER_SUCCESS,
      error: CHANGE_SERVICE_ORDER_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

export const getSettingsPerState = () => {
  const endpoint = 'api/v1/settings'
  const action = {
    type: GET_STATES_SETTINGS,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_STATES_SETTINGS_SUCCESS,
      error: GET_STATES_SETTINGS_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
